import NBType, { InferType } from '@netbase/nb-type'
import MetricCategoryItem from '../enums/MetricCategoryItem'

/*
 * TODO:
 * Not generated by java-to-js, so nb-type could be removed in the future and replaced with TypeScript.
 * The corresponding TimelineSeriesVo is only used to initialize data which functionality can be handled by TypeScript as well.
 */
const TimelineSeriesSchema = NBType.object().shape('TimelineSeriesSchema', {
  /* @prop */
  topicId: NBType.number(),
  /* @prop */
  topicName: NBType.string(),
  /* @prop */
  type: NBType.string(),
  /* @prop */
  isSupported: NBType.boolean(),
  /* @prop */
  isNegative: NBType.boolean(),
  /* @prop */
  isNoCount: NBType.boolean(),
  /* @prop */
  category: NBType.enum(MetricCategoryItem),
  /* @prop */
  isChild: NBType.boolean(),
  /* @prop */
  isDash: NBType.boolean(),
  /* @prop */
  data: NBType.array().of(NBType.number())
  /* END */
})

export default TimelineSeriesSchema
export type TimelineSeries = InferType<typeof TimelineSeriesSchema>
